import { Body } from "@vds/typography";
import {
  Container,
  GreyText,
  InputHeaderTitle,
  Section,
} from "../../Rules/Rulesstyle";
import { Icon } from "@vds/icons";
import DisplayCanvas from "../../../polygonLib/displayPolygonLib/displayCanvas";
import {
  formatTimeFrame,
  formatLocalTime,
} from "../../../global/utility/Utils";
import { transformPolygonData } from "../../../global/utility/roiUtils";
import { EVENTS_INFO_CONSTANTS } from "../../../global/constants/constants";
const AlertAccordion = ({ state, imageUrl, isLoading }) => {
  const imageSize = { width: 200, height: 128 };
  //This variable will come to action when no polygon receiving for corresponding Roi 
  //Ex: stream monitoring or object blurring .
  const statePolygon_default = EVENTS_INFO_CONSTANTS.DEFAULT_POLYGON_POINTS;
  if (
    !state?.ruleId ||
    state?.ruleId?.length === 0 ||
    !state?.ruleConfig?.ruleName
  ) {
    return (
      <Body color="#A7A7A7" bold={true} size="large">
        This Alert is no longer available.
      </Body>
    );
  }

  return (
    <div className="alertAccordion-container">
      <div>
        <InputHeaderTitle className="alertAccordion-header-title">
          Alert name
        </InputHeaderTitle>
        <Body size="large">{state?.ruleConfig?.ruleName}</Body>
      </div>
      <Container>
        <Section>
          <InputHeaderTitle>Regions of Interest</InputHeaderTitle>
          <div>
            {isLoading ? (
              <Body color="#A7A7A7" bold={false} size="small">
                Loading...
              </Body>
            ) : !isLoading && (!imageUrl || imageUrl == "") ? (
              <Body color="#EE0000" bold={false} size="small">
                Failed to load image.
              </Body>
            ) : (

                <DisplayCanvas
                  videoSource={imageUrl}
                  imageSize={imageSize}
                  initialPolygons={transformPolygonData(state?.polygon ?? statePolygon_default)}
                  originalSize={[
                    { polygon: state?.polygon  ?? statePolygon_default},
                    { polygon: state?.polygon ?? statePolygon_default }
                  ]}
                  alertAccordion={true}
                />

            )}
          </div>
        </Section>
      </Container>

      <div>
        <InputHeaderTitle className="alertAccordion-header-title">
          Trigger
        </InputHeaderTitle>
      <div className="alertAccordion-trigger-row">
        <Icon name="reports-and-alerts" size="20px" color="grey" />
        <GreyText bold size="large">
          Condition:
        </GreyText>
        <Body size="large">
          {state?.ruleConfig?.condition ? state?.ruleConfig?.condition : "NA"}
        </Body>
      </div>
      <div className="alertAccordion-timeframe-row">
        <Icon name="clock" size="20px" color="grey" />
        <GreyText bold size="large">
          Timeframe:
        </GreyText>
        <Body size="large">
          {state?.ruleConfig?.timeFrame?.isAlwaysActive &&
          state?.ruleConfig?.timeFrame?.isAlwaysActive === "true"
            ? "Always active"
            : formatTimeFrame(
                formatLocalTime(state?.ruleConfig?.timeFrame?.startTime)
                  ?.formatOnlyTime,
                formatLocalTime(state?.ruleConfig?.timeFrame?.endTime)
                  ?.formatOnlyTime,
                state?.ruleConfig?.timeFrame?.days
              )}
        </Body>
      </div>
      </div>
    </div>
  );
};

export default AlertAccordion;
